import { config } from '../_config';
import { authHeader, handleResponse } from '../_helpers';

export const phoneService = {
    update,
    create,
    delete: _delete
};


function update(phone) {
    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(phone)
    };

    return fetch(`${config.apiUrl}/phones/${phone.id}`, requestOptions).then(handleResponse);
}

function create(phone) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(phone)
  };

  return fetch(`${config.apiUrl}/phones`, requestOptions).then(handleResponse);
}


function _delete(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };
    return fetch(`${config.apiUrl}/phones/${id}`, requestOptions).then(handleResponse);
}

